import { useTranslation } from './useTranslation';
import { KNOWLEDGE_LANGUAGE_KEYS } from '../constants/knowledgeConstants';
import { TranslationResources } from '../types/i18n';

const useKnowledgeLanguageOptions = () => {
  const { t } = useTranslation();

  return KNOWLEDGE_LANGUAGE_KEYS.map(lang => ({
    label: t(lang.labelKey as keyof TranslationResources),
    value: lang.value,
  }));
};

export default useKnowledgeLanguageOptions;
